import { amountToDisplayValue, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface SubjectPaymentAmountProps {
  accountCurrencyId?: string
  convertedSubjectsAmountsSum: number
  subjectCurrencyId?: string
  selectedSubjectsAmountsSum: number
  isCrossCurrency: boolean
  shouldShowPaymentAmount: boolean
}

export const SubjectPaymentAmount = ({
  accountCurrencyId,
  subjectCurrencyId,
  convertedSubjectsAmountsSum,
  selectedSubjectsAmountsSum,
  isCrossCurrency,
  shouldShowPaymentAmount,
}: SubjectPaymentAmountProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="row" justifyContent="center" alignItems="end" gap={Spacing.S12}>
      {isCrossCurrency && (
        <Flex flexDirection="row" justifyContent="center" alignItems="center" gap={Spacing.S8}>
          <Text variant="bodySM" colorVariant="secondary">
            {t('subject.payment_reconcile.cross_currency.estimated_conversion')}
          </Text>
          <Flex alignItems="center" justifyContent="center" gap={Spacing.S4}>
            <Text weight="bold" colorVariant="secondary">
              {convertedSubjectsAmountsSum}
            </Text>
            <Text colorVariant="secondary">{accountCurrencyId}</Text>
          </Flex>
        </Flex>
      )}
      <Flex flexDirection="column">
        <Text variant="bodySM" colorVariant="secondary" alignment="right">
          {t('incl_vat')}
        </Text>
        <Flex alignItems="center" justifyContent="center" gap={Spacing.S4}>
          <Text weight="bold">
            {shouldShowPaymentAmount ? amountToDisplayValue(selectedSubjectsAmountsSum, false) : '-'}
          </Text>
          <Text>{subjectCurrencyId}</Text>
        </Flex>
      </Flex>
    </Flex>
  )
}
